// src/components/Footer.js
import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import '../assets/styles/footer.css'; // Make sure this path is correct

// Define your map center
const center = [12.979330, 80.131650]; // [latitude, longitude]

// Custom component to fit bounds (if needed)
function FitBounds({ bounds }) {
    const map = useMap();
    useEffect(() => {
        if (bounds) {
            map.fitBounds(bounds);
        }
    }, [bounds, map]);
    return null;
}

const Footer = () => {
    const [bounds, setBounds] = useState(null);

    useEffect(() => {
        // Create bounds based on your locations
        const newBounds = L.latLngBounds(center, center);
        setBounds(newBounds);
    }, []);

    // Define custom marker icon
    const customIcon = new L.Icon({
        iconUrl: 'https://www.svgrepo.com/show/532543/location-plus.svg', // Path to your custom image in the public directory
        iconSize: [32, 32], // Size of the icon [width, height]
        iconAnchor: [16, 32], // Point of the icon which will correspond to marker's location [x, y]
        popupAnchor: [0, -32] // Point from which the popup should open relative to the iconAnchor [x, y]
    });

    return (
        <div className="footer">
            <div className="footer-left">
                <h3 className='footer-title'>APPOINTMENT</h3>
                <p className='footer-subtitle'>Crafting Your Next Masterpiece</p>
                <p className='footer-timing'>Mon – Sun 10:00 AM – 08:00 PM</p>
                <p className='footer-location-city'>Pammal:</p>
                <p className='footer-location-address'>
                    No 113/2, balaraj nadar complex, Pammal Main Rd, Pasumpon Nagar, Pammal, Chennai, Tamil Nadu 600075
                </p>
                <p className='footer-contact'>
                    Phone Number: <span className='footer-contact-number'>+91 9941894196</span>
                </p>
            </div>
            <div className="footer-right">
                <MapContainer
                    center={center}
                    zoom={15}
                    style={{ height: '400px', width: '100%' }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <Marker position={center} icon={customIcon}>
                        <Popup>
                            Your Location
                        </Popup>
                    </Marker>
                    <FitBounds bounds={bounds} />
                </MapContainer>
            </div>
        </div>
    );
};

export default Footer;